import script from "./teamGiftList.vue?vue&type=script&setup=true&lang=js"
export * from "./teamGiftList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__